import { Component, Output, ViewChild, ElementRef, OnInit, EventEmitter } from '@angular/core';
import { TitleRequestsService } from '../title-requests/title-requests.service';
import { ToasterService } from 'angular2-toaster';
import { InAppNotificationsService } from '../../notifications/notifications.service';
import { UserDetailsService } from '../../shared/user.details.service';
import { CatalogService } from '../catalog-api/catalog.service';
import { ApiConstants } from '../../shared';
// tslint:disable-next-line:import-blacklist
import { Subject } from 'rxjs';
import { GeneralConstants } from '../../shared/general.constants';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'harvesting',
    templateUrl: 'harvesting.component.html',
    styleUrls: ['harvesting.component.scss']
})
export class HarvestingComponent implements OnInit {
    @Output() onHandleOpen = new EventEmitter();

    @ViewChild('modal', { read: ElementRef }) modal: ElementRef;
    private modalType;
    private rejectMessage;

    private selectedTypeIndex;
    private selectedTitleName;
    private selectedTitleRequest;
    private isAdmin;
    private isTitleCreationApprover;
    private username;

    private titleRequests = [];
    private hasMore = false;
    private page = 0;
    private results = [];

    private loading = false;
    private approveLoading = false;
    private rejectLoading = false;

    private batchIdOrDescription = '';
    private language;
    private country;
    private network;
    private year = '';

    private languages;
    private languageValues;
    private countries;
    private countryValues;
    private networks;
    private yearSubject = new Subject<string>();
    private batchIdOrDescriptionSubject = new Subject<string>();
    private contentType: number = 0;
    private contentTypeValue: string = 'show';

    onContentTypeChange(value: number) {
        this.contentType = value;

        if (value === 0) {
            this.contentTypeValue = 'show';
        }
        if (value === 1) {
            this.contentTypeValue = 'movie';
        }
        if (value === 2) {
            this.contentTypeValue = 'talent';
        }
        if (value === 3) {
            this.contentTypeValue = 'sports';
        }

    }

    constructor(private titleRequestsService: TitleRequestsService,
        private notificationsService: InAppNotificationsService,
        private userDetailsService: UserDetailsService,
        private catalogService: CatalogService,
        private toasterSerivce: ToasterService,
        private apiConstants: ApiConstants,
        private generalConstants: GeneralConstants) { }

    ngOnInit() {
        this.isAdmin = this.userDetailsService.isAdmin();
        this.isTitleCreationApprover = this.userDetailsService.isTitleCreationApprover();
        this.username = this.userDetailsService.getUsername();
        this.languages = ['None'].concat(this.apiConstants.LANGUAGES.map(item => item.name));
        this.languageValues = [''].concat(this.apiConstants.LANGUAGES.map(item => item.code));
        this.countries = ['None'].concat(this.apiConstants.COUNTRIES.map(item => item.displayName));
        this.countryValues = [''].concat(this.apiConstants.COUNTRIES.map(item => item.iso));
        this.networks = ['None'].concat(this.apiConstants.NETWORKS);

        // Initialize the debounce for the year
        this.yearSubject.debounceTime(this.generalConstants.getDebounceTime())
            .distinctUntilChanged()
            .subscribe(year => {
                this.updateSearchTerm('year', year);
            });

        this.batchIdOrDescriptionSubject.debounceTime(this.generalConstants.getDebounceTime())
            .distinctUntilChanged()
            .subscribe(batchId => {
                this.updateSearchTerm('batchId', batchId);
            });
    }

    private handleGetTitleRequests() {
        if (!this.isTitleCreationApprover) {
            this.toasterSerivce.pop('error', 'Your account lacks permission to get view title requests!');
            return;
        }
        this.titleRequests = [];
        this.loading = true;
        this.selectedTypeIndex = 0;
        this.page = 0;
        this.getTitleRequests();
    }

    private async handleLoadMore() {
        this.page = this.page + 1;
        let parrotID = [];
        switch (this.selectedTypeIndex) {
            case 0:
                this.getTitleRequests();
                break;
            case 1:
                parrotID = await this.getByState('requested');
                break;
            case 2:
                parrotID = await this.getByState('harvested');
                break;
            case 3:
                parrotID = await this.getByState('demand_generation');
                break;
        }
    }

    private async getByState(state: string) {
        const query = this.catalogService.getHarvestingEsQueryObject();
        if (state === 'requested') {
            query['query']['bool']['must'] = [
                {
                    'terms': {
                        'catalog_state': [state]
                    }
                }
            ];
        } else {
            query['query']['bool']['must'] = [
                {
                    'terms': {
                        'catalog_state': [state]
                    }
                }
            ];
        }

        const filters = this.createFilters();
        if (filters) {
            query['query']['bool']['must'] = query['query']['bool']['must'].concat(filters);
        }
        query['from'] = this.page * query['size'];
        query['_source'] = this.catalogService.getEsDefaultSource();
        query['sort'] = this.catalogService.getESPrioritySortObject();

        // console.log(JSON.stringify(query));

        if (this.contentType === 0) {
            await this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'helpdesk_internal_data')
                .then(async (res) => {
                    this.hasMore = (query['from'] + query['size']) < res.hits.total.value;
                    const parrotIDList = [];
                    let internalDataresults = [];
                    internalDataresults = internalDataresults.concat(res.hits.hits.map(item => this.catalogService.mapInternalMetadataResultItem(item, 'show')));

                    for (const internalDataresult of internalDataresults) {
                        parrotIDList.push(internalDataresult.parrotId);
                    }
                    console.log(parrotIDList);
                    await this.getValuesByState(parrotIDList, state);
                    this.loading = false;
                    return parrotIDList;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                    return [];

                });
        }
        if (this.contentType === 1) {
            this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'helpdesk_internal_data')
                .then(async (res) => {
                    this.hasMore = (query['from'] + query['size']) < res.hits.total.value;
                    // console.log(res);
                    const parrotIDList = [];
                    let internalDataresults = [];
                    internalDataresults = internalDataresults.concat(res.hits.hits.map(item => this.catalogService.mapInternalMetadataResultItem(item, 'movie')));

                    for (const internalDataresult of internalDataresults) {
                        parrotIDList.push(internalDataresult.parrotId);
                    }
                    console.log(parrotIDList);
                    await this.getValuesByState(parrotIDList, state);
                    this.loading = false;

                    return parrotIDList;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                    return [];

                });
        }
        if (this.contentType === 2) {
            this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'helpdesk_internal_data')
                .then(async (res) => {
                    this.hasMore = (query['from'] + query['size']) < res.hits.total.value;
                    const parrotIDList = [];
                    let internalDataresults = [];
                    internalDataresults = internalDataresults.concat(res.hits.hits.map(item => this.catalogService.mapInternalMetadataResultItem(item, 'talent')));

                    for (const internalDataresult of internalDataresults) {
                        parrotIDList.push(internalDataresult.parrotId);
                    }
                    console.log(parrotIDList);
                    await this.getValuesByState(parrotIDList, state);
                    this.loading = false;

                    return parrotIDList;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                    return [];

                });
        }
        if (this.contentType === 3) {
            this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'helpdesk_internal_data')
                .then(async (res) => {
                    this.hasMore = (query['from'] + query['size']) < res.hits.total.value;
                    const parrotIDList = [];
                    let internalDataresults = [];
                    internalDataresults = internalDataresults.concat(res.hits.hits.map(item => this.catalogService.mapInternalMetadataResultItem(item, 'sports')));

                    for (const internalDataresult of internalDataresults) {
                        parrotIDList.push(internalDataresult.parrotId);
                    }
                    console.log(parrotIDList);
                    await this.getValuesByState(parrotIDList, state);
                    this.loading = false;

                    return parrotIDList;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                    return [];

                });
        }

        return [];

        // this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'master_tv_catalog')
        //     .then((res) => {
        //         this.hasMore = (query['from'] + query['size']) < res.hits.total.value;
        //         this.results = this.results.concat(res.hits.hits.map(this.catalogService.mapEsResultItem));
        //         this.loading = false;
        //     })
        //     .catch((err) => {
        //         console.error('Failed to load harvesting queue: ' + err.toString());
        //         this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
        //         this.loading = false;
        //     });
    }

    private getValuesByState(parrotIdList, catalogState) {

        const queryString = {
            'query': {
                'bool': {
                    'must': [
                        {
                            'terms': {
                                'parrot_id': parrotIdList
                            }
                        }, {
                            'match': {
                                'catalog_state': catalogState
                            }
                        }
                    ]
                }
            }, 'size': 200
        };

        const query = JSON.stringify(queryString) ;
        // console.log(JSON.stringify(query));

        if ( this.contentType === 0) {
            this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'series_metadata')
                .then((res) => {
                    this.results = this.results.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, 'tv')));
                    this.loading = false;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                });
        }
        if ( this.contentType === 1) {
            this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'movie_metadata')
                .then((res) => {
                    // console.log(res);
                    this.results = this.results.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, 'movie')));
                    this.loading = false;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                });
        }
        if ( this.contentType === 2) {
            this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'talent_metadata')
                .then((res) => {
                    this.results = this.results.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, 'talent')));
                    this.loading = false;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                });
        }
        if ( this.contentType === 3) {
            this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'sports_metadata')
                .then((res) => {
                    this.results = this.results.concat(res.hits.hits.map(item => this.catalogService.mapEsMetadataResultItem(item, 'sports')));
                    this.loading = false;
                })
                .catch((err) => {
                    console.error('Failed to load harvesting queue: ' + err.toString());
                    this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
                    this.loading = false;
                });
        }

        // this.catalogService.callEsProxyCustomQueryNewMetadata(query, 'master_tv_catalog')
        //     .then((res) => {
        //         this.hasMore = (query['from'] + query['size']) < res.hits.total.value;
        //         this.results = this.results.concat(res.hits.hits.map(this.catalogService.mapEsResultItem));
        //         this.loading = false;
        //     })
        //     .catch((err) => {
        //         console.error('Failed to load harvesting queue: ' + err.toString());
        //         this.toasterSerivce.pop('error', 'Failed to load harvesting queue');
        //         this.loading = false;
        //     });
    }

    private async handleGetHarvestingQueue() {

        this.results = [];
        this.loading = true;
        this.page = 0;
        this.selectedTypeIndex = 1;
        const parrotID = await this.getByState('requested');
    }

    private async handleGetHarvestingQA() {

        this.results = [];
        this.loading = true;
        this.page = 0;
        this.selectedTypeIndex = 2;
        const parrotID = await this.getByState('harvested');
    }

    private async handleGetCustomerReadyCheck() {
        if (!this.isAdmin) {
            this.toasterSerivce.pop('error', 'Must be an admin to get view title requests!');
            return;
        }

        this.results = [];
        this.loading = true;
        this.page = 0;
        this.selectedTypeIndex = 3;
        const parrotID = await this.getByState('demand_generation');
    }

    handleRejected(titleRequest) {
        this.selectedTitleRequest = titleRequest;
        this.openModal('reject');
    }

    handleSubmitReject() {
        this.rejectLoading = true;
        const rejectSubject = `Title request rejected for ${this.selectedTitleRequest.title} in batch with id ${this.selectedTitleRequest.batchId}`;
        Promise.all([
            this.notificationsService.postNotification(
                this.selectedTitleRequest.requestUser, this.username, rejectSubject, this.rejectMessage),
            this.titleRequestsService.updateTitleRequest(this.selectedTitleRequest.id, this.username, 'REJECTED')
        ])
            .then((res) => {
                this.rejectLoading = false;
                this.titleRequests = this.titleRequests.filter((titleRequest => titleRequest !== this.selectedTitleRequest));
                this.closeModal();
                this.toasterSerivce.pop('success', 'Successfully rejected the selected title request!');
            })
            .catch((err) => {
                console.error('Failed to submit rejection for a title request: ' + err.toString());
                this.toasterSerivce.pop('error', 'Failed to reject the selected title request!');
                this.rejectLoading = false;
            });
    }

    handleApprove(titleRequest) {
        this.selectedTitleRequest = titleRequest;
        this.selectedTitleName = titleRequest.title;
        this.openModal('approve');
    }

    async handleSubmitApprove() {
        this.approveLoading = true;
        // console.log(res)
        try {
            const res = await this.titleRequestsService.updateTitleRequest(this.selectedTitleRequest.id, this.username, 'APPROVED', this.selectedTitleRequest.priority);
            this.titleRequests = this.titleRequests.filter((titleRequest => titleRequest !== this.selectedTitleRequest));
            this.closeModal();
            this.toasterSerivce.pop('success', 'Successfully approved the selected title request!');
            this.approveLoading = false;
        } catch (err) {
            console.error('Failed to submit approval for a title request: ' + err.toString());
            this.toasterSerivce.pop('error', 'Failed to approve the selected title request!');
            this.approveLoading = false;
        }
    }

    handleOpen(result) {
        this.onHandleOpen.emit({
            parrotId: result.parrotId,
            title: result.title,
            displayName: result.displayName,
            catalogState: result.catalogState,
            contentType: result.contentType

        });
    }

    updateSearchTerm(type, value) {
        // Update language, country or network
        switch (type) {
            case 'language':
                this.language = value;
                break;
            case 'country':
                this.country = value;
                break;
            case 'network':
                this.network = value;
                break;
            case 'year':
                this.year = value;
                break;
            case 'batchId':
                this.batchIdOrDescription = value;
                break;
        }
        // Set the page to 0
        this.page = 0;
        // Search again using the selected index
        const selectedTypeIndex = this.selectedTypeIndex;
        // Set the selectedTypeIndex to undefined to skip the check at the start of each function
        this.selectedTypeIndex = undefined;
        switch (selectedTypeIndex) {
            case 0:
                this.handleGetTitleRequests();
                break;
            case 1:
                this.handleGetHarvestingQueue();
                break;
            case 2:
                this.handleGetHarvestingQA();
                break;
            case 3:
                this.handleGetCustomerReadyCheck();
                break;
        }
    }

    createFilters() {
        // Return an object of term filters to concat to the bool->must part of the query
        const filters = [];
        if (this.language) {
            filters.push(this.catalogService.createMultiMatchObject('phrase', ['data.original_language.*'], this.language));
        }
        if (this.country) {
            filters.push(this.catalogService.createMultiMatchObject('phrase', ['data.original_country.*'], this.country));
        }
        if (this.network && this.network !== 'None') {
            filters.push(this.catalogService.createMultiMatchObject('phrase', ['data.original_network.*'], this.network));
        }
        if (this.batchIdOrDescription) {
            filters.push({ 'match': { 'internal_data.notes.content': this.batchIdOrDescription } });
        }
        return filters;
    }

    async getTitleRequests() {
        const network = this.network && this.network !== 'None' && this.network;
        const res = await this.titleRequestsService.getTitleRequests(this.page, 'incomplete', this.batchIdOrDescription, this.country, network, this.year, this.contentTypeValue);
        // console.log(res)
        try {
            const titleRequests = res.titleRequests.map(this.titleRequestsService.mapTitleRequests)
                .map((item) => {
                    return {
                        ...item,
                        // tslint:disable-next-line:no-shadowed-variable
                        additionalInfoString: [item.country, item.year, item.network].filter( item => item ).join(' - '),
                        edit: false
                    };
                });
            this.hasMore = res.hasMore;
            if (this.titleRequests.length > 0) {
                this.titleRequests = this.titleRequests.concat(titleRequests);
            } else {
                this.titleRequests = titleRequests;
            }
            this.loading = false;
        } catch (err) {
            console.error('Failed to get incomplete title requests: ', err.toString());
            this.toasterSerivce.pop('error', 'Failed to get incomplete title requests');
            this.loading = false;
            this.selectedTypeIndex = undefined;
        };
    }

    editTitleRequest(titleRequest) {
        titleRequest.edit = true;
    }

    cancelTitleRequestEdit(titleRequest) {
        titleRequest.edit = false;
    }

    updateTitleRequest(titleRequest) {
        titleRequest.loading = true;
        this.titleRequestsService.updateTitleRequestName(titleRequest.id, titleRequest.title)
            .then((res) => {
                if (res.message !== 'Successfully updated the title request!') {
                    console.error(`Failed to update title request title, invalid response received: ${res}`);
                    this.toasterSerivce.pop('error', 'Failed to updated title for title request');
                }
                this.toasterSerivce.pop('success', 'Successfully updated title for title request!');
                titleRequest.loading = false;
                titleRequest.edit = false;
            })
            .catch((err) => {
                console.error(`Failed to update title request title: ${err}`);
                this.toasterSerivce.pop('error', 'Failed to update title for title request');
                titleRequest.loading = false;
                titleRequest.edit = false;
            });
    }

    openModal(modalType: string) {
        this.modalType = modalType;
        this.modal.nativeElement.style.display = 'block';
    }

    closeModal() {
        this.modal.nativeElement.style.display = 'none';
    }
}



// WEBPACK FOOTER //
// ./src/app/catalogue/harvesting/harvesting.component.ts